export function checkProperties(obj: any) {
  for (let key in obj) {
    if (obj[key] === "" || obj[key] === null) {
      return false;
    }
  }
  return true; // Se nenhuma propriedade for vazia ou nula, retorna verdadeiro
}